import React, { useEffect, useState } from "react";
import { Button, Modal, Form, Select, Input, InputNumber } from "antd";

import * as Common from "../commons/common";
import * as Types from "../commons/typeDTO";
import * as String from "../commons/string";
import * as Request from "../commons/request";
import * as Utils from "../utils/utils";

import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";
import moment from "moment";

function ModalAddRentPayment({
    rent,
    rentPayment,
    open,
    onChangedOpen,
    onChangedPayment,
}: {
    rent: Types.RentDto;
    rentPayment?: Types.RentPaymentDto;
    open: boolean;
    onChangedOpen: (open: boolean) => void;
    onChangedPayment?: (type: string, value: any) => void;
}) {
    const paymentMethod = [
        // { type: "ONLINE", lable: String.online },
        { type: "OFFLINE_BANK", lable: String.offline_bank },
        { type: "OFFLINE_CARD", lable: String.offline_card },
        { type: "OFFLINE_CASH", lable: String.offline_cash },
    ];

    const { Option } = Select;
    const [form] = Form.useForm();

    const [paymentCategories, setPaymentCategories] = useState<Array<Types.RentPaymentCategoryDto>>();
    const [currentCategory, setCurrentCategory] = useState<Types.RentPaymentCategoryDto>();
    const [currentPaymentItem, setCurrentPaymentItem] = useState<Types.RentPaymentItemDto>();

    useEffect(() => {
        form.resetFields();
        if (open) requestGetPaymentCategories();
    }, [open]);

    const requestAxiosGetPaymentCategories = async () => {
        const response = await utilAxiosWithAuth().get(Request.RENT_PAYMENT_CATEGORIES_URL);
        return response.data;
    };

    const {
        loading: loadingGetPaymentCategories,
        error: errorGetPaymentCategories,
        data: resultGetPaymentCategories,
        execute: requestGetPaymentCategories,
    } = useAsyncAxios(requestAxiosGetPaymentCategories);

    useEffect(() => {
        if (resultGetPaymentCategories === null) return;
        console.log("resultGetPaymentCategories", resultGetPaymentCategories);
        setPaymentCategories(resultGetPaymentCategories.rentPaymentCategories);
    }, [resultGetPaymentCategories]);

    useEffect(() => {
        if (errorGetPaymentCategories === null) return;
        console.log("errorGetPaymentCategories", errorGetPaymentCategories);
    }, [errorGetPaymentCategories]);

    // useEffect(() => {
    //     form.setFieldsValue(rentPayment);
    // }, [rentPayment]);

    useEffect(() => {
        if (currentPaymentItem !== undefined) {
            form.setFieldValue("basicPrice", Utils.getPaymentItemAmount(rent, currentPaymentItem));
            form.setFieldValue("amount", Utils.getPaymentItemAmount(rent, currentPaymentItem));
        }
    }, [currentPaymentItem]);

    useEffect(() => {
        if (rentPayment !== undefined) {
            form.setFieldsValue(rentPayment);
            form.setFieldValue("rentPaymentType", rentPayment.rentPaymentItem.rentPaymentCategory.rentPaymentCategoryId);
            setCurrentCategory(
                paymentCategories?.find(
                    (category) => category.rentPaymentCategoryId === rentPayment.rentPaymentItem.rentPaymentCategory.rentPaymentCategoryId
                )
            );

            form.setFieldValue("rentPaymentItem", rentPayment.rentPaymentItem.rentPaymentItemId);
        }
    }, [paymentCategories]);

    const handleClose = () => {
        onChangedOpen(false);
    };

    const onFinish = (values: any) => {
        if (onChangedPayment === undefined) {
            onChangedOpen(false);
        } else {
            if (rentPayment === undefined && currentPaymentItem === undefined) {
                // TODO: error popup
                return;
            }

            if (rentPayment) {
                const payment: any = {
                    rent: rent,
                    rentPaymentId: rentPayment.rentPaymentId,
                    basicPrice: values.basicPrice,
                    paymentMethod: values.paymentMethod,
                    adjustedPrice: values.amount - values.basicPrice,
                    amount: values.amount,
                };
                if (values.paymentMethod) {
                    payment.paidDate = Utils.localTimeToUtc(moment().format(Common.FORMAT_DATE_TIME), Common.FORMAT_DATE_TIME);
                } else {
                    payment.paidDate = null;
                    payment.paymentMethod = null;
                }
                if (values.memo) payment.memo = values.memo;

                onChangedPayment("update", payment);
            } else {
                const payment: any = {
                    rent: rent,
                    rentPaymentType: "PENALTY",
                    rentPaymentItem: currentPaymentItem,
                    basicPrice: values.basicPrice,
                    paymentMethod: values.paymentMethod,
                    adjustedPrice: values.amount - values.basicPrice,
                    amount: values.amount,
                };
                if (values.paymentMethod) {
                    payment.paidDate = Utils.localTimeToUtc(moment().format(Common.FORMAT_DATE_TIME), Common.FORMAT_DATE_TIME);
                }
                if (values.memo) payment.memo = values.memo;

                onChangedPayment("add", payment);
            }
        }
    };

    const onChangeData = () => {
        const basicPrice = form.getFieldValue("basicPrice");
        const adjustedPrice = form.getFieldValue("adjustedPrice");

        let amount = 0;
        if (adjustedPrice === null) amount = basicPrice;
        else amount = adjustedPrice;

        form.setFieldValue("amount", amount);
    };

    return (
        <Modal
            centered
            closable={false}
            className="login"
            open={open}
            title={rentPayment ? "결제 수정" : "결제 추가"}
            onOk={handleClose}
            onCancel={handleClose}
            footer={[
                <Button key="back" onClick={handleClose}>
                    취소
                </Button>,
                <Button key="payment" type="primary" onClick={() => form.submit()}>
                    {rentPayment ? "수정" : "추가"}
                </Button>,
            ]}
        >
            <Form labelCol={{ span: 4 }} wrapperCol={{ span: 20 }} form={form} onFinish={onFinish} initialValues={{ paymentMethod: "OFFLINE_BANK" }}>
                <Form.Item name="paymentMethod" label="결제방법">
                    <Select placeholder="결제방법" showSearch allowClear>
                        {paymentMethod &&
                            paymentMethod.map((payment) => (
                                <Option key={payment.type} value={payment.type}>
                                    {payment.lable}
                                </Option>
                            ))}
                    </Select>
                </Form.Item>
                <Form.Item name="rentPaymentType" label="구분">
                    <Select
                        placeholder="구분"
                        showSearch
                        allowClear
                        disabled={rentPayment ? true : false}
                        onChange={(value) =>
                            setCurrentCategory(paymentCategories?.find((category) => category.rentPaymentCategoryId === Number(value)))
                        }
                    >
                        {paymentCategories &&
                            paymentCategories.length > 0 &&
                            paymentCategories.map((categroy) => (
                                <Option key={categroy.rentPaymentCategoryId} value={categroy.rentPaymentCategoryId}>
                                    {categroy.rentPaymentCategoryName}
                                </Option>
                            ))}
                    </Select>
                </Form.Item>
                <Form.Item name="rentPaymentItem" label="위반내용">
                    <Select
                        placeholder="위반내용"
                        showSearch
                        allowClear
                        disabled={rentPayment ? true : false}
                        onChange={(value) =>
                            setCurrentPaymentItem(
                                currentCategory?.rentPaymentItems?.find((paymentItem) => paymentItem.rentPaymentItemId === Number(value))
                            )
                        }
                    >
                        {currentCategory &&
                            currentCategory.rentPaymentItems?.length > 0 &&
                            currentCategory.rentPaymentItems?.map((paymentItem) => (
                                <Option key={paymentItem.rentPaymentItemId} value={paymentItem.rentPaymentItemId}>
                                    {paymentItem.rentPaymentItemName}
                                </Option>
                            ))}
                    </Select>
                </Form.Item>
                <Form.Item name="basicPrice" label="책정요금">
                    <InputNumber disabled placeholder="금액" onChange={onChangeData}></InputNumber>
                </Form.Item>
                <Form.Item name="adjustedPrice" label="조정요금">
                    <InputNumber placeholder="금액" onChange={onChangeData}></InputNumber>
                </Form.Item>
                <Form.Item name="amount" label="정산요금">
                    <InputNumber placeholder="금액" disabled></InputNumber>
                </Form.Item>
                <Form.Item name="memo" label="메모">
                    <Input placeholder="메모"></Input>
                </Form.Item>
            </Form>
        </Modal>
    );
}

export default ModalAddRentPayment;
